import React from 'react';
import type { TFunction } from 'i18next';

import type { VisitorPassQueryResponse } from 'application-types';

import { INVITE_NAME_MAX_DISPLAY_LENGTH } from '../../constants';
import { TruncateTextComponent } from '../../components/TruncateText/TruncateText';

export type VisitorLogInviteNameColumn = {
  header: React.ReactNode;
  /** Translated column title for CSV export (required because `header` is JSX). */
  csvHeader: string;
  key: string;
  renderCell: (
    cell: unknown,
    row: VisitorPassQueryResponse
  ) => React.ReactNode;
  renderForCSV: (
    cell: unknown,
    visitorPass: VisitorPassQueryResponse
  ) => string;
};

function formatInviteNameCellValue(inviteName: string | undefined | null): string {
  return inviteName ?? '';
}

/** Invite name column for visitor log tables; enable only when VisitorInviteName flag is on. */
export function getVisitorLogInviteNameColumns(
  t: TFunction,
  isEnabled: boolean | undefined
): VisitorLogInviteNameColumn[] {
  if (!isEnabled) {
    return [];
  }

  const inviteNameLabel = t('web.admin.channel.visitor.log.columns.inviteName');

  return [
    {
      header: (
        <span
          data-test="visitorLogInviteNameColumnHeader"
          style={{ marginLeft: 0, paddingLeft: 0 }}
        >
          {inviteNameLabel}
        </span>
      ),
      csvHeader: inviteNameLabel,
      key: 'inviteName',
      renderCell: (_cell, row) => (
        <span data-test="visitorLogInviteNameCell">
          <TruncateTextComponent
            text={formatInviteNameCellValue(row.inviteName)}
            maxLength={INVITE_NAME_MAX_DISPLAY_LENGTH}
          />
        </span>
      ),
      renderForCSV: (_cell, visitorPass) =>
        formatInviteNameCellValue(visitorPass.inviteName),
    },
  ];
}
